<template>
  <div class="campaingContentUpdatePage">
    <div class="loadingDiv" v-if="fetchingData" v-loading="true" style="min-height: 300px"></div>

    <template v-if="!fetchingData">
      <!-- Campaign Steps -->
      <CampaignSteps v-if="campaign" :step="step" :campaign="campaign"></CampaignSteps>

      <!-- Step Header -->
      <div class="campaignStepHeader">
        <el-button class="prevButton" type="warning" plain size="mini" :loading="savingCampaign" @click="onGoBack">
          <i class="el-icon-back"></i>
          &nbsp; Target Audiance
        </el-button>

        <span class="headerTitle"> Campaign Contents </span>

        <el-button class="nextBtn" type="primary" size="mini" :loading="savingCampaign" @click="onGoNext">
          Save & Continue &nbsp;
          <i class="el-icon-arrow-right el-icon-right"></i>
        </el-button>
      </div>

      <div class="campaignInfo">
        <WebSocialProofBuilder ref="contentBuilder"></WebSocialProofBuilder>
      </div>
    </template>
  </div>
</template>

<style lang="scss" src="./updateCampaignContent.scss"></style>

<script>
import CampaignSteps from '@/components/campaign/createCampaignSteps';
import campaignContnetUtil from './updateCampaignContentMethods';
import WebSocialProofBuilder from '@/components/campaign/contentBuilder/webSocialProof/webSocialProofEditor';

export default {
  name: 'updateWebSocialProofContent',
  props: {},
  components: {
    CampaignSteps,
    WebSocialProofBuilder
  },
  data() {
    return {
      step: 2,
      fetchingData: true,

      campaignId: null,
      campaign: null,
      content: null,

      // targetAudianceStepErrors: [],
      savingCampaign: false

      // hasUnsavedChanges: false
    };
  },
  mixins: [],
  watch: {
    targetAudiance: {
      deep: true,
      handler() {
        this.hasUnsavedChanges = true;
      }
    }
  },
  methods: {
    async fetchContents() {
      await campaignContnetUtil.fetchCampaignContent(this);
    },
    async validateAndSave() {
      await campaignContnetUtil.validateAndSave(this);
    },
    async onGoBack() {
      await campaignContnetUtil.goBack(this);
    },
    async onGoNext() {
      await campaignContnetUtil.onGoNext(this);
    },
    async onSaveDraft() {
      await campaignContnetUtil.saveDraft(this);
    }
  },

  mounted() {
    this.campaignId = this.$route.params.id;
    this.fetchContents();
  }
};
</script>
